export default {
  "content": "<path d=\"M12 3c4.97 0 9 4.044 9 9.033 0 4.618-3.453 8.427-7.91 8.967v-6.206h2.435l.506-2.76-2.94-.001v-.976c0-1.459.57-2.02 2.046-2.02a21.792 21.792 0 01.823.017c.083.005.156.01.216.017V6.568a2.355 2.355 0 00-.104-.026 10.48 10.48 0 00-1.853-.198c-3.007 0-4.393 1.425-4.393 4.5v1.189H7.97v2.76h1.856V20.8A9.03 9.03 0 013 12.033C3 7.044 7.03 3 12 3z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};